import { Link } from 'react-router-dom';
import { tvShows } from '@/mocks/tvShows';
import SectionTitle from '@/components/base/SectionTitle';

const categoryNameMap: Record<string, string> = {
  action: '动作冒险',
  suspense: '悬疑惊悚',
  scifi: '科幻奇幻',
  drama: '剧情爱情',
  crime: '犯罪刑侦',
  comedy: '喜剧',
  horror: '恐怖',
};

export default function LatestUpdates() {
  const latest = tvShows.filter((s) => s.latest).sort((a, b) => b.updateTime.localeCompare(a.updateTime)).slice(0, 8);

  return (
    <section className="py-10 md:py-14 bg-background-100">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <SectionTitle
          title="最新更新"
          subtitle="第一时间获取最新剧集更新信息"
          href="/category/all"
        />
        <div className="bg-background-50 rounded-lg border border-background-200/70 overflow-hidden">
          {latest.map((show, index) => (
            <Link
              key={show.id}
              to={`/detail/${show.id}`}
              className={`flex items-center gap-4 p-4 hover:bg-background-100 transition-colors cursor-pointer ${
                index !== latest.length - 1 ? 'border-b border-background-200/70' : ''
              }`}
            >
              <div className="w-12 h-16 rounded overflow-hidden flex-shrink-0">
                <img
                  src={show.poster}
                  alt={show.name}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-semibold text-foreground-950 truncate">{show.name}</h3>
                <p className="text-xs text-foreground-400 mt-0.5">{show.englishName}</p>
              </div>
              <div className="hidden sm:flex items-center gap-2 flex-wrap">
                <span className="text-xs px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 whitespace-nowrap">
                  {categoryNameMap[show.categories[0]] || show.categories[0]}
                </span>
                <span className="text-xs text-primary-500 font-medium whitespace-nowrap">{show.rating}</span>
              </div>
              <div className="text-right flex-shrink-0">
                <p className="text-xs text-foreground-600 whitespace-nowrap">{show.latestEpisode}</p>
                <p className="text-xs text-foreground-400 mt-0.5 whitespace-nowrap">{show.updateTime}</p>
              </div>
              <i className="ri-arrow-right-s-line text-foreground-300 hidden sm:block" />
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}